// extracted by mini-css-extract-plugin
export default {"VerifyTwoFA__Card":"NZeyx9nG3X","VerifyTwoFA__Card__split":"JK7jCxEgBh"};